export const getProductsSuccess = (products) => {
    return {
        type: "GET_PRODUCTS_SUCCESS",
        payload: products
    }
};
